/**
 * Design-Tokens der Firmen-Website https://deutsche-foerderberatung.de/
 * (Auftrag Alex 31.07.2026, docs/tasks/upload-lp-website-stil.md).
 *
 * Gilt NUR fuer die oeffentlichen Kundenseiten (kundenUpload, ggf.
 * kundenTermin) — bewusst getrennt vom CRM-Theme, KEIN Umbau des
 * BW-Themes. Werte aus dem Elementor-Kit der Website extrahiert
 * (post-8.css: --e-global-color-*, --e-global-typography-*; Details in
 * der Stil-Notiz der Task-Datei).
 *
 * Hex ist hier die dokumentierte CI-Ausnahme (CLAUDE.md §5): das ist
 * die Website-CI, sie existiert im BW-Theme absichtlich nicht.
 *
 * Fonts: Die Website nutzt "Google Sans Flex" (Headlines) und "Satoshi"
 * (Fliesstext) — beides Fremd-Assets mit ungeklaerter Weitergabe-Lizenz,
 * die wir NICHT buendeln (Rechtefrage wie die Presselogos). Die Stacks
 * nennen sie vorn und fallen auf das bereits geladene "Inter" zurueck;
 * liefert die Firma spaeter lizenzierte Font-Dateien, greifen sie ohne
 * Codeaenderung.
 */
export const WEBSITE_STIL = {
  /** e-global-color-primary — Headlines + Fliesstext */
  navy: '#162036',
  /** dunkle Flaechen + Button-Text der Website */
  navyTief: '#021128',
  /** e-global-color-accent — CTAs, Sterne */
  gold: '#C8A54D',
  /** abgeleitet (Website definiert im gezogenen CSS keinen Accent-Hover) */
  goldHover: '#B6923F',
  /** helle Sektions-/Seitenflaeche der Website */
  flaeche: '#EEF3FA',
  weiss: '#FFFFFF',
  /** Karten durchgehend 16px, Buttons/Leisten als Pille */
  kartenRadius: '16px',
  pillenRadius: '100px',
  /** weicher Karten-Schatten auf der hellen Flaeche (Website-Karten) */
  kartenSchatten: '0 8px 24px rgba(2, 17, 40, 0.08)',
  /** Weiss-Abstufungen der Website auf dunklen Sektionen (post-31.css: #FFFFFFDB/#FFFFFFA3) */
  heroText: '#FFFFFFDB',
  heroTextDezent: '#FFFFFFA3',
  schriftHeadline: '"Google Sans Flex", "Inter", "Segoe UI", sans-serif',
  schriftText: '"Satoshi", "Inter", "Segoe UI", sans-serif',
  /** Headline-Metrik der Website: 600, -0.04em, 1.15 */
  headlineSpacing: '-0.04em',
  headlineHoehe: 1.15,
  /** Fliesstext-Metrik der Website: 400, 1.64 */
  textHoehe: 1.64,
} as const;
